import ResetPassword from "components/pages/ResetPassword"

function ResetPasswordPage() {
  return <ResetPassword />
}

export default ResetPasswordPage
